"use client";

import React from "react";
import { Plus, Minus, CircleQuestionMark } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const faqs = [{
  question: "Quais tratamentos a Dil Saúde Capilar oferece?",
  answer: "Oferecemos uma gama completa de serviços em tricologia e terapia capilar, incluindo diagnóstico detalhado com tricoscopia, tratamentos para quedas e alopecias (como eflúvio e calvície), controle de oleosidade, caspa e psoríase, além de protocolos para restauração de danos químicos e manutenção preventiva da saúde dos fios."
}, {
  question: "Como funciona a avaliação inicial?",
  answer: "Nossa consulta começa com uma investigação capilar detalhada, utilizando escaneamento tricoscópico de alta precisão. Avaliamos os óstios foliculares, a epiderme, a vascularização e a haste capilar, além de realizar o pull test. Com base nessas evidências, prescrevemos um protocolo totalmente personalizado."
}, {
  question: "O que é Tricologia e para quem é indicada?",
  answer: "A Tricologia é a área que estuda e trata patologias do couro cabeludo e dos fios. É indicada para quem sofre com queda excessiva, falhas, descamação, coceira, oleosidade ou danos por química. Nosso foco é diagnosticar a causa raiz e promover a saúde capilar de dentro para fora."
}, {
  question: "Vocês atendem apenas o público feminino?",
  answer: "Sim, a Dil Saúde Capilar é especializada no atendimento ao público feminino. Criamos um ambiente acolhedor, moderno e focado no bem-estar da mulher, com protocolos desenvolvidos especificamente para as necessidades hormonais e capilares femininas."
}, {
  question: "Qual o endereço e horário de funcionamento?",
  answer: "Estamos localizados na Rua das Flores, 123 - Centro, Cidade, Estado. Nosso atendimento ocorre de segunda a sexta-feira, das 09h00 às 18h00, e aos sábados mediante agendamento prévio."
}, {
  question: "É necessário agendar horário?",
  answer: "Sim, para garantir um atendimento humanizado, exclusivo e sem pressa, atendemos apenas com hora marcada. Você pode agendar sua avaliação entrando em contato conosco através do nosso telefone ou WhatsApp."
}];
export default function FaqSection() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="dúvidas-frequentes" ref={ref} className="bg-background relative overflow-hidden py-20 sm:py-28">
      {}
      <div className="pointer-events-none absolute -top-24 -right-24 h-96 w-96 rounded-full bg-primary/5 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 -left-24 h-96 w-96 rounded-full bg-secondary/5 blur-3xl" />

      <div className={cn("container mx-auto px-4 transition-all duration-1000 ease-out", isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0")}>
        <div className="mx-auto max-w-3xl text-center">
          <div className="mb-4 inline-flex items-center justify-center rounded-full bg-primary/10 px-3 py-1 text-sm font-medium text-primary">
            <CircleQuestionMark className="mr-2 size-4" />
            Dúvidas Frequentes
          </div>
          <h2 className="font-serif text-foreground mb-6 text-3xl font-bold md:text-4xl lg:text-5xl">
            Perguntas Frequentes
          </h2>
          <p className="text-muted-foreground mb-12 text-lg leading-relaxed">
            Confira as respostas para as principais dúvidas sobre nossos
            tratamentos de tricologia e terapia capilar.
          </p>
        </div>

        <div className="mx-auto max-w-3xl">
          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-primary/10 bg-card/50 hover:border-primary/30 overflow-hidden rounded-xl border px-2 transition-colors duration-300">
                <AccordionTrigger className="group hover:no-underline [&>svg:last-child]:hidden py-5 px-4">
                  <div className="flex w-full items-center justify-between gap-4">
                    <span className="font-serif text-foreground text-left text-lg font-medium group-hover:text-primary transition-colors">
                      {faq.question}
                    </span>
                    <div className="bg-background border-primary/20 group-hover:border-primary/50 relative flex size-8 shrink-0 items-center justify-center rounded-full border shadow-sm transition-all duration-300">
                      <Plus className="text-primary absolute size-4 transition-transform duration-300 group-data-[state=open]:rotate-90 group-data-[state=open]:opacity-0" />
                      <Minus className="text-primary absolute size-4 rotate-90 opacity-0 transition-transform duration-300 group-data-[state=open]:rotate-0 group-data-[state=open]:opacity-100" />
                    </div>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground px-4 pb-6 text-base leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>

          <div className="mt-12 text-center">
            <p className="text-muted-foreground mb-6">
              Ainda tem dúvidas? Entre em contato com nossa equipe.
            </p>
            <Button asChild size="lg" className="rounded-full px-8">
              <Link to="/SchedulingPage">Agendar Avaliação</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}